export const REGEXP = {
    EMAIL: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
    PASSWORD: /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/, // at least 8 characters, must contain at least one letter UPPER case, one lower case and a number
};

export const PUBLIC_EMAIL_DOMAINS = [
    'aol.com',
    'free.fr',
    'gmail.com',
    'gmx.com',
    'gmx.fr',
    'googlemail.com',
    'hotmail.com',
    'hotmail.fr',
    'icloud.com',
    'laposte.net',
    'live.com',
    'live.fr',
    'me.com',
    'msn.com',
    'orange.fr',
    'outlook.com',
    'outlook.fr',
    'proton.me',
    'protonmail.com',
    'sfr.fr',
    'wanadoo.fr',
    'yahoo.com',
    'yahoo.fr',
];

export const jobTitleOptions = [
    'generalCounsel',
    'lawyer',
    'documentalist',
    'secretaryGeneral',
    'salesDirector',
    'financialDirector',
    'generalManager',
    'legalOfficer',
    'other',
];
